import './css/Three.css';
import  { useRef, useState, Suspense } from 'react';
import { Canvas, useLoader, useFrame } from '@react-three/fiber';
import { useGLTF, OrbitControls, OrthographicCamera } from '@react-three/drei';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
function Model1() {
  const gltf = useGLTF('/assets/models/Mole.glb');
  return <primitive object={gltf.scene} />;
}


function Box(props) {
  // This reference gives us direct access to the THREE.Mesh object
  const ref = useRef();
  // Hold state for hovered and clicked events
  const [hovered, hover] = useState(false);
  const [clicked, click] = useState(false);

  // Subscribe this component to the render-loop, rotate the mesh every frame
  useFrame((state, delta) => (ref.current.rotation.y += 0.01));
  useFrame((state, delta) => (ref.current.rotation.x += 0.01));

  // Return the view, these are regular Threejs elements expressed in JSX
  return (
    <mesh
      {...props}
      ref={ref}
      scale={clicked ? 1.5 : 1}
      onClick={(event) => click(!clicked)}
      onPointerOver={(event) => hover(true)}
      onPointerOut={(event) => hover(false)}
    >
      <boxGeometry args={[1, 1, 1]} />
      <meshStandardMaterial color={hovered ? 'green' : 'blue'} />
    </mesh>
  );
}
console.log('Box', Box);
//https://stackoverflow.com/questions/71589738/how-do-i-properly-use-drei-usegltf
/**
 * Creates a canvas, camera, ambient light and imports a model located in the public assets of this project
 * @returns
 */
function Three2Layout_fromStack() {
  return (
    <div className="container-fluid">
      <Suspense>
        <Canvas>
          <OrthographicCamera makeDefault position={[0, 0, 100]} />
          <OrbitControls />
          <ambientLight />
        </Canvas>
      </Suspense>
    </div>
  );
}

export default Three2Layout_fromStack;
